import { h, Component } from 'preact'; // eslint-disable-line no-unused-vars
import { FavouriteIcon } from '../../icons/favourite-icon';

export class ProductCard extends Component {
    constructor(props) {
        super(props);
    }

    // need to add a GTM thing here for handle the (Select Item) event which is supposed to happen on click on the image or button (product__summary__more-info)
    

    render() {
        var prodTypeClass = '';
        if (typeof this.props.type === 'string') { prodTypeClass = `product-info--${this.props.type.toLowerCase().replace(/\s/g, '-')}`; }
        
        const prodMainImage = { backgroundImage: `url(${ this.props.primaryImageUrl })` }

        const prodSpec = () => {
            var productSpecHtml = '';
            if(this.props.type !== 'Land' && this.props.type !== 'Apartment') {
                productSpecHtml = (
                    <div class="product-info__stats-container">
                        {this.props.lot.lotSize && (<div class="product-info__stats product-info__stats--area" title="Lot size">{ this.props.lot.lotSize }</div>)}
                        {this.props.lot.lotWidth && (<div class="product-info__stats product-info__stats--width" title="Frontage">{ this.props.lot.lotWidth }</div>)}
                        {this.props.bedrooms && (<div class="product-info__stats product-info__stats--beds" title="Number of beds">{ this.props.bedrooms }</div>)}
                        {this.props.bathrooms && (<div class="product-info__stats product-info__stats--baths" title="Number of baths">{ this.props.bathrooms }</div>)}
                        {this.props.garageSpaces && (<div class="product-info__stats product-info__stats--cars" title="Number of cars bays">{ this.props.garageSpaces }</div>)}
                        {this.props.storeys && (<div class="product-info__stats product-info__stats--storeys" title="Number of storeys">{ this.props.storeys }</div>)}                        
                    </div>
                )
            }            
            else if(this.props.type !== 'Land') {
                productSpecHtml = (
                    <div class="product-info__stats-container">
                        {this.props.bedrooms && (<div class="product-info__stats product-info__stats--beds" title="Number of beds">{ this.props.bedrooms }</div>)}
                        {this.props.bathrooms && (<div class="product-info__stats product-info__stats--baths" title="Number of baths">{ this.props.bathrooms }</div>)}
                        {this.props.garageSpaces && (<div class="product-info__stats product-info__stats--cars" title="Number of cars bays">{ this.props.garageSpaces }</div>)}
                        {this.props.storeys && (<div class="product-info__stats product-info__stats--storeys" title="Number of storeys">{ this.props.storeys }</div>)}
                    </div>
                )
            }
            else if(this.props.type == 'Land') {
                productSpecHtml = (
                    <div class="product-info__stats-container">
                        {this.props.lot.lotSize && (<div class="product-info__stats product-info__stats--area" title="Lot size">{ this.props.lot.lotSize }</div>)}
                        {this.props.lot.lotWidth && (<div class="product-info__stats product-info__stats--width" title="Frontage">{ this.props.lot.lotWidth }</div>)}
                    </div>
                )
            }            
            return productSpecHtml;
        }

        const name = () => {
            var nameHtml = '';
            if (this.props.lot.marketingReleaseName !== null && this.props.lot.marketingReleaseName !== '') {
                nameHtml = this.props.name + ' - ' + this.props.lot.marketingReleaseName;
            } else {
                nameHtml = this.props.name;
            }

            return nameHtml;
        }

        return (
            <div class={`product__summary ${prodTypeClass}`}>
                <a class="product__summary__thumbnail-wrapper" href={this.props.url} style={prodMainImage} onClick={() => clicked(this.props)} target="_blank">
                    <div class="product__summary__category">{ this.props.type }</div>
                </a>
                <strong class="product__summary__price">{ this.props.priceDescription }</strong>
                {this.props.builderName && (
                    <a href={ this.props.builderUrl } target="_blank">
                        <img alt={ this.props.builderName } class="builder-logo" src={ this.props.productLogoUrl } />
                    </a>    
                )}
                <h2 class="product__summary__title">
                    <span class="product__summary__name">{ name() }</span>
                </h2>
                { prodSpec() }
                <div class="product__summary__more-info">
                    {/* TODO: Favourties toggle... */}
                    {/* <label class="product__summary__favourite-toggle">
                        <input type="checkbox" name="favourite" value={ProductID} checked={IsFavouriteProduct}/>
                        <input type="checkbox" name="favourite" value="true" checked="true"/>
                        <FavouriteIcon />
                    </label> */}
                    <a class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored" href={this.props.url} onClick={() =>  clicked(this.props) } target="_blank">More Information</a>
                </div>
            </div>
        )

    }

}

export class ProductEmptyState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="product-search__empty">
                <h4>Due to popular demand, our products are selling quickly.</h4>
                <p>Please keep an eye on this page, or register your details to be among the first to know once {this.props.project} has products available.</p>
                <a class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored mdl-button--full-width" href="javascript:void(lightbox.show(null, 'updates'));(renderReCaptcha('g-recaptcha-sign-up-form'));">Register</a>
            </div>
        )
    }

}

function clicked(props) {
    console.log("(Select Item) fired in product");
    // TODO missing open times
    let product = {
        item_id: getGUIDfromURL(props.url),
        item_name: props.lot.name,
        item_brand: props.builderName,
        lot_name: props.name,
        lot_type: props.type,
        lot_size: props.lot.lotSize,
        lot_price: props.price,
        lot_stage: props.lot.release.name,
        lot_bedrooms: props.bedrooms,
        lot_bathrooms: props.bathrooms,
        lot_car_spaces: props.garageSpaces,
        lot_stories: props.storeys,
        lot_product_id: getGUIDfromURL(props.url),
        lot_open_times: "not available at this time", //'{{ Opening Hours }}', // 7 days a week 11am - 5pm. Public Holidays 1pm - 5pm. // TODO need to get from backend so it can travel through to here
        lot_builder: props.builderName,
        lot_frontage: props.lot.lotWidth
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "select_item",
        ecommerce: {
            item_list_name: "Lot List",            
            items:[product]
            
            
        }
    });
}

function getGUIDfromURL(url) {
    // get stuff between {} and send it back
    var guid = url.substring(url.indexOf("{") + 1, url.lastIndexOf("}"));
    return guid;
}
